export const FORM_BUILDER_COMPONENTS = [
    {
        type: 'additionalNotes',
        description: 'Notes'
    },
    {
        type: 'attachment',
        description: 'Attachment'
    },
    {
        type: 'checkboxQuestion',
        description: 'Checkbox'
    },
    {
        type: 'multipleChoice',
        description: 'Multiple Choice'
    },
    {
        type: 'signature',
        description: 'Signature'
    },
    {
        type: 'singleChoice',
        description: 'Single Choice'
    },
    {
        type: 'singleText',
        description: 'Single Line'
    },
    {
        type: 'textBox',
        description: 'Textbox'
    },
]